module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAClSURBVDiNpZJbDcJAFETPEASsBBxQFLAOQAISqIJKACl1UByABCTUwfCzTfhot4+dn93kZk7mPqBQArAdgcNKby+pJQE6r1cHsCttIQfogWd6twEk1cAJ+GwBACDpC7ym6vuMN9iugAcQNwGA91zC4i0MCSaHlNG4x3a0HZZShlMOwBU4Ave0+3rG20rq/4d4Bqr0D8Bl5ojasfjBdmP7trSFYv0ANBRjBpAVShIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video.png
// module id = +vEQ
// module chunks = 1